import { memo, useMemo, useState } from "react";
import { Colors } from "../../utils/colors";
import LoginWelcomeBody from "../../components/Login/LoginWelcomeBody";
import RectangleButton from "../../components/Buttons/RectangleButton";
import { getUserData } from "../../utils/FirebaseUtils";
import useAsyncOnMount from "../../hooks/useAsyncEffectOnMount";
import { useSelector } from "react-redux";
import { AppState } from "../../redux/store";
import { TeamMemberRole } from "@markit/common.types";

type LoginOnboardingTeamMemberWelcomeProps = {
  teamOwnerUid: string;
  continueOnPress: () => void;
};

const LoginOnboardingTeamMemberWelcome = (
  props: LoginOnboardingTeamMemberWelcomeProps
) => {
  const { teamOwnerUid, continueOnPress } = props;
  const { teamMemberData } = useSelector((state: AppState) => state.account);
  const [adminName, setAdminName] = useState("");

  const CAPABILITIES = useMemo(() => {
    const visibleCapabilities = [
      {
        title: "Two-way messaging",
        description: "Respond to your Markit subscribers",
        disabled: false,
      },
    ];
    if (teamMemberData?.role === TeamMemberRole.FULL_ACCESS) {
      visibleCapabilities.push({
        title: "Full capabilities",
        description: "Create products & events, send texts, and more",
        disabled: false,
      });
    }
    visibleCapabilities.push({
      title: "Billing & plan",
      description: `Managed by ${adminName}`,
      disabled: true,
    });
    return visibleCapabilities;
  }, [teamMemberData, adminName]);

  useAsyncOnMount(async () => {
    const ownerData = await getUserData(teamOwnerUid);
    if (ownerData) {
      setAdminName(ownerData.fullName);
    }
  });

  return (
    <LoginWelcomeBody
      title="Welcome to your workspace"
      subtext={`Here's what you can do as a${teamMemberData ? ` ${teamMemberData.role}` : ""} team member for ${adminName}.`}
    >
      <div className="ColumnNormal" style={{ gap: 14, width: "100%" }}>
        {CAPABILITIES.map((capability: any) => (
          <div
            key={capability.title}
            className="ColumnNormal"
            style={{
              gap: 4,
              border: `1px solid ${Colors.GRAY4}`,
              borderRadius: 12,
              padding: 14,
              width: "100%",
              boxSizing: "border-box",
              backgroundColor: capability.disabled
                ? Colors.WHITE1
                : Colors.WHITE,
              opacity: capability.disabled ? 0.6 : 1,
            }}
          >
            <span className="bodyMedium">{capability.title}</span>
            <span className="smallBodySubtext">{capability.description}</span>
          </div>
        ))}
      </div>
      <RectangleButton
        buttonLabel="Continue"
        onPress={continueOnPress}
        altColor={Colors.BLACK}
        altTextColor={Colors.WHITE}
        altPaddingVert={14}
      />
    </LoginWelcomeBody>
  );
};

export default memo(LoginOnboardingTeamMemberWelcome);
